import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Constants } from '../common';
import { BaseResponse } from '../models/responses';

@Injectable({
  providedIn: 'root'
})
export class CrediserverService {

  constructor(private http: HttpClient) { }

  LoadCrediserverPeople(): Observable<BaseResponse> {
    return this.http.get<BaseResponse>(
      `${Constants.API_URL}api/Crediserver/GetCrediserverPersons`)
  }
}
